import translations from './translations';

export const legalCopy = language => {
  const locale = String(language).trim().toLowerCase().split(/[-_]/)[0];
  return Object.prototype.hasOwnProperty.call(translations, locale) ? translations[locale] : translations.en;
};
